<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        
                        <div class="vx-col sm:w-full md:w-full lg:w-full mx-auto self-center  d-theme-dark-bg">
                            <div class="px-8 pt-8 register-tabs-container">
                                <div class="vx-card__title mb-4">
                                    <h4 class="mb-4"><router-link :to="{name:'login'}" class="text-inherit underline">Login</router-link></h4>
                                    
                                    <p>The world's most advanced real estate valuation tool.</p>

                                    <p><router-link :to="{name:'register'}" class="text-inherit underline">Start Pricing Homes Today</router-link></p>

                                    <p>Your value! Not a computer generated Price.</p>

                                    <p>New to ValueNet?</p>

                                    <vs-input
                                      v-validate="'required|email'"
                                      data-vv-validate-on="blur"
                                      name="email"
                                      type="email"
                                      label-placeholder="Email"
                                      placeholder="Email"
                                      v-model="email"
                                      class="w-full mt-6" />
                                    <span class="text-danger text-sm">{{ errors.first("email") }}</span>

                                    <vs-button class="float-right mt-6" @click="handleRegister" >Register Here</vs-button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </vx-card>
                    </div>
                      </div>
</template>

<script>

export default {
  name: 'Landing',
  data () {
    return {
      email: '',
      error: ''
    }
  },
  methods: {
    handleRegister () {
      this.$validator.validate().then(isValid => {
        if (isValid) {
          this.$router.push(`/register?email=${this.email}`)
        }
      })
    }
  }
}
</script>
